import * as React from 'react';

const useMutationConfig = ({ onError , onCompleted  } = {})=>{
    /**
   *  Callback to handle mutation error
   */ const handleMutationError = React.useCallback((error)=>{
        onError === null || onError === void 0 ? void 0 : onError({
            reason: 'MUTATION',
            error
        });
    }, [
        onError
    ]);
    /**
   *  Configuration to call mutation
   *  of GQL
   */ const mutationOptions = React.useMemo(()=>{
        return {
            onError: handleMutationError,
            onCompleted: (data)=>{
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(data);
            }
        };
    }, [
        handleMutationError,
        onCompleted
    ]);
    return {
        mutationOptions
    };
};

export { useMutationConfig };
//# sourceMappingURL=use-mutation-config.js.map
